// Add your custom JS here.
const galleryBtn = document.getElementById('galleryBtn');
const gallery = document.getElementsByClassName('gallery-img');

galleryBtn.addEventListener("click", function(event) {
    event.preventDefault();    
    for (let i = 6; i < gallery.length; i++) {
        gallery[i].style.display = "flex";
    }
    event.target.style.display = "none";
});